"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.show = show;
exports.default = void 0;

var _search = require("modals/search");

var _SearchControl2 = babelHelpers.interopRequireDefault(require("components/SearchControl"));

var BrandSearchControl =
/*#__PURE__*/
function (_SearchControl) {
  babelHelpers.inherits(BrandSearchControl, _SearchControl);

  function BrandSearchControl() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, BrandSearchControl);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(BrandSearchControl)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this._useTag = false;
    return _this;
  }

  babelHelpers.createClass(BrandSearchControl, [{
    key: "render",
    value: function render() {
      this._useTag = true;
      var r = babelHelpers.get(babelHelpers.getPrototypeOf(BrandSearchControl.prototype), "render", this).call(this);
      this._useTag = false;
      r.props.className += " brand-search-control";
      return r;
    }
  }, {
    key: "x_getSearchProperties",
    value: function x_getSearchProperties() {
      var ps = Object.assign({}, this.props.searchProperties || {}); // if (this.state.removedTag) delete ps.brandId;

      if (this._useTag) {// if (ps.brandId)
        //	ps.tag = this.props.brandName;
      }

      return ps;
    }
  }], [{
    key: "getControl",
    value: function getControl(identifier) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Evil.
      var r = babelHelpers.get(babelHelpers.getPrototypeOf(BrandSearchControl), "getControl", this).call(this, identifier, props);
      r.type = BrandSearchControl;
      return r;
    }
  }]);
  return BrandSearchControl;
}(_SearchControl2.default);

var BrandModal =
/*#__PURE__*/
function (_SearchModal) {
  babelHelpers.inherits(BrandModal, _SearchModal);

  function BrandModal(brandId, brandTitle) {
    var _this2;

    babelHelpers.classCallCheck(this, BrandModal);
    _this2 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(BrandModal).call(this, 'brand-' + brandId));
    _this2.options = {
      brandId: brandId,
      brandTitle: brandTitle
    };
    return _this2;
  }

  babelHelpers.createClass(BrandModal, [{
    key: "getControl",
    value: function getControl() {
      return BrandSearchControl.getControl("brand-".concat(this.options.brandId), {
        brandName: this.options.brandTitle,
        searchProperties: {
          brandId: this.options.brandId
        }
      });
    }
  }, {
    key: "title",
    get: function get() {
      return this.options.brandTitle;
    }
  }]);
  return BrandModal;
}(_search.SearchModal);

exports.default = BrandModal;

function show(brandId, brandTitle) {
  var b = new BrandModal(brandId, brandTitle);
  b.show();
}